/** The base name, or its first free numbered variation. */
export function nextUntitledName(existing: Iterable<string>, base = "Untitled dashboard"): string {
  const names = new Set([...existing].map((name) => name.trim().toLowerCase()));
  let name = base;
  let suffix = 2;
  while (names.has(name.toLowerCase())) name = `${base} ${suffix++}`;
  return name;
}
